import React, { useState, useContext } from "react";
import { useTranslation } from "react-i18next";
import { ValidatePDFContext } from "../../../contexts/ValidatePDFContext";
import { Grid, Typography, Box, Button } from "@mui/material";
import { useAuth0 } from "@auth0/auth0-react";
import { addProgressAnalysisCommentReport } from "../../../services/Exam";
import AddCommentModal from "../AddCommentModal";
import { getLocalDate } from "../../../utils/dateHelper";
import useClinic from "../../../hooks/useClinic";
import { ModalCustomDark } from "../../../styles/muiStylesHelper";
import { SpeechBubbleIcon } from "../../../assets/icons";

const ReportInfoHeaderComponentAnalysis = ({
  isWiderThanSmallScreen,
  rightText,
  clinicId,
  patient,
  progressionAnalysisId,
}) => {
  const { t } = useTranslation();
  const { clinicName, clinicTimezone } = useClinic();
  const { getAccessTokenSilently } = useAuth0();
  const { forBackendPdf } = useContext(ValidatePDFContext);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const submitComment = async (commentData) => {
    const token = await getAccessTokenSilently();
    return addProgressAnalysisCommentReport(
      token,
      clinicId,
      patient?.id,
      progressionAnalysisId,
      commentData
    );
  };

  return (
    <>
      <Grid container item py={1} px={1} display="flex" flexDirection="column">
        <Box
          display="flex"
          justifyContent="space-between"
          width="100%"
          alignItems={{ xs: "flex-start", sm: "center" }}
          flexDirection={{ xs: "column", sm: "row" }}
        >
          <Box display="flex" flexDirection="column">
            <Typography
              variant={isWiderThanSmallScreen ? "h6" : "body1"}
              fontWeight="bold"
              fontSize={18}
              maxWidth="300px"
              overflow="hidden"
              whiteSpace="nowrap"
              textOverflow="ellipsis"
            >
              {`${t("devices_table_name")}: ${patient?.firstName} ${patient?.lastName}`}
            </Typography>
            <Box display="flex" flexDirection="row" width="100%" gap={1}>
              <Typography variant="body1" fontSize={14}>
                <span
                  style={{ fontWeight: "bold" }}
                >{`${t("patients_modal_sex")}: `}</span>
                <span>{patient?.sex}</span>
              </Typography>
              <Typography variant="body1" fontSize={14}>
                <span
                  style={{ fontWeight: "bold" }}
                >{`${t("report_age")}: `}</span>
                <span>{patient?.age}</span>
              </Typography>
              <Typography variant="body1" fontSize={14}>
                <span
                  style={{ fontWeight: "bold" }}
                >{`${t("patients_modal_birth")}: `}</span>
                <span>
                  {getLocalDate(patient?.dateOfBirth, clinicTimezone)}
                </span>
              </Typography>
            </Box>
          </Box>
          <Box textAlign={{ xs: "left", sm: "right" }}>
            <Typography variant="body1" fontSize="14px">
              {clinicName}
            </Typography>
            <Typography
              variant="body1"
              fontSize="14px"
              textTransform="capitalize"
            >
              {rightText}
            </Typography>
          </Box>
        </Box>
        {!forBackendPdf && (
          <Box display="flex" width="100%" mt={1} justifyContent="flex-end">
            <Button
              onClick={handleOpen}
              startIcon={<SpeechBubbleIcon />}
              sx={{
                ...ModalCustomDark(),
                width: { xs: "100%", sm: "fit-content" },
              }}
            >
              {t("word_add_comment")}
            </Button>
          </Box>
        )}
      </Grid>

      <AddCommentModal
        isOpen={open}
        handleClose={handleClose}
        submitComment={submitComment}
      />
    </>
  );
};

export default ReportInfoHeaderComponentAnalysis;
